import React from 'react'
import {Button, Modal} from 'react-bootstrap'

const ConfirmationModel = ({show, handleClose, message, setAllow}: any) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered'>
        <div className='modal-header text-center row'>
          <div className='icon-box col-12'>
            <i className={`fa fa-exclamation-circle fa-2x `}></i>
          </div>
          <h2>Are you sure?</h2>
        </div>
        <div className='modal-body'>{message}</div>
        <div className='modal-footer'>
          <Button
            color='secondary'
            onClick={() => {
              setAllow(false)
              handleClose()
            }}
          >
            Cancel
          </Button>{' '}
          <Button
            color='danger'
            onClick={() => {
              setAllow(true)
              handleClose()
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default ConfirmationModel
